export const postureRuntimeErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('Exception in Sim Timeline') !== -1 && (desyncdata.indexOf('RuntimeError: Posture Entry') !== -1 || desyncdata.indexOf('RuntimeError: Posture Exit') !== -1)) {
			return {
				type: 'postureEntryExitRuntimeError',
				color: 'MediumAquamarine',
				title: 'Posture Runtime Error',
				text: 'Possibly base game issue with Sim posture.',
				description: 'Sim posture is missing data to continue performing. For the most part, you\'re safe to ignore this error.'
			}
		}

		if (desyncdata.indexOf('Exception in Sim Timeline') !== -1 && desyncdata.indexOf('Failed to create new_posture_spec in enter_carry_while_holding') !== -1) {
			return {
				type: 'newPostureRuntimeError',
				color: 'MediumAquamarine',
				title: 'Posture Runtime Error',
				text: 'Possibly base game issue with Sim posture.',
				description: 'Sim carry posture failed to be created due to missing data. For the most part, you\'re safe to ignore this error.'
			}
		}

		if (desyncdata.indexOf('Exception in Sim Timeline') !== -1 && desyncdata.indexOf('failed to find carry posture aop for carry target') !== -1) {
			return {
				type: 'failedCarryPostureRuntimeError',
				color: 'MediumAquamarine',
				title: 'Posture Runtime Error',
				text: 'Possibly base game issue with Sim posture.',
				description: 'Sim failed to find an appropriate carry posture to pick up an object. For the most part, you\'re safe to ignore this error.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
	<report>
		<version>2</version>
		<sessionid>c21d32bea9fc38bb5b63a127</sessionid>
		<type>desync</type>
		<sku>ea.maxis.sims4_64.15.pc</sku>
		<createtime>2099-08-06 20:59:59</createtime>
		<buildsignature>Local.Unknown.Unknown.1.99.62.1020-1.200.000.360.Release</buildsignature>
		<categoryid>posture.py:1947</categoryid>
		<desyncid>c21d32bea9fc38bb5b63a127</desyncid>
		<systemconfig/>
		<screenshot/>
		<desyncdata>Exception in Sim Timeline: Exception running Element (RuntimeError: Posture Exit(posture_CarryNothing:845) called multiple times without a paired entry. Sim: )
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 376, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture.py&quot;, line 1959, in _do_end
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture.py&quot;, line 1947, in get_end
RuntimeError: Posture Exit(posture_CarryNothing:845) called multiple times without a paired entry. Sim: 
</desyncdata>
	</report>
</root>
*/

/*
<root>
    <report>
        <version>2</version>
        <sessionid>139319bad5f0c7c5ba1709c</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2088-09-18 19:18:47</createtime>
        <buildsignature>Local.Unknown.Unknown.1.88.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>posture_state.py:155</categoryid>
        <desyncid>139319bad5f0c7c5ba1709c</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception in Sim Timeline: Exception running Element (RuntimeError: ('Sim {} failed to find carry posture aop for carry target {}.', &lt;sim '' 0x4e082168c52607&gt;, object_foodPlatter(0x0000000000000000)))
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 376, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 4021, in do_transition_single
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3962, in _create_transition_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3943, in run_transition_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3578, in create_transition
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 4020, in create_posture_state_func
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 4011, in _create_posture_state
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\posture_state.py&quot;, line 155, in __init__
RuntimeError: ('Sim {} failed to find carry posture aop for carry target {}.', &lt;sim '' 0x4e082168c52607&gt;, object_foodPlatter(0x0000000000000000))
</desyncdata>
    </report>
</root>
*/

export const postureFailedCarryHandError = ({
    buildsignature,
    categoryid,
    createtime,
    desyncdata,
    desyncid,
    screenshot,
    sessionid,
    sku,
    systemconfig,
    type,
    version,
}) => {
    if (desyncdata !== undefined) {
        if (desyncdata.indexOf('failed to find a hand to carry object') !== -1) {
            return {
                type: 'postureFailedCarryHandError',
                color: 'MediumAquamarine',
                title: 'Sim Posture Carry Hand Error',
                text: 'Possibly base game issue with Sim failing to find carry hand.',
                description: 'The game failed to find a hand to an carry object with. For the most part, you\'re safe to ignore this error.'
            }
        }
    }
}

/*
<root>
    <report>
        <version>2</version>
        <sessionid>7975047d12ae0e905ca5ba1d</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-04-04 10:18:01</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.67.1020-1.200.000.385.Release</buildsignature>
        <categoryid>transition_sequence.py:1781</categoryid>
        <desyncid>7975047d12ae0e905ca5ba1d</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Sim  failed to find a hand to carry object object_BakingPan:0x02fc0928457f05d5 (IndexError: tuple index out of range)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 463, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\time_service.py&quot;, line 112, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 217, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 385, in _resume
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_service.py&quot;, line 496, in _process_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_service.py&quot;, line 433, in _update_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 251, in run_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1386, in _run_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1808, in _score_object_interactions_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 970, in _test_aop
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\aop.py&quot;, line 166, in test
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 2702, in test
  File &quot;T:\InGame\Gameplay\Scripts\Server\crafting\crafting_interactions.py&quot;, line 1266, in _test
  File &quot;T:\InGame\Gameplay\Scripts\Server\crafting\crafting_process.py&quot;, line 536, in resume_test
  File &quot;T:\InGame\Gameplay\Scripts\Server\crafting\crafting_process.py&quot;, line 1315, in _find_phase_affordances
  File &quot;T:\InGame\Gameplay\Scripts\Server\crafting\crafting_process.py&quot;, line 1269, in run_request
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_service.py&quot;, line 172, in score_all_interactions
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_service.py&quot;, line 188, in score_all_interactions_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 251, in run_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1386, in _run_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1833, in _score_object_interactions_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1921, in _create_and_score_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\autonomy\autonomy_modes.py&quot;, line 1028, in _calculate_route_time_and_opportunity
  File &quot;T:\InGame\Gameplay\Scripts\Core\caches.py&quot;, line 156, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2461, in estimate_distance
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2501, in _estimate_distance
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2380, in _generate_connectivity
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1457, in compute_transition_connectivity
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1504, in run_transitions
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3361, in _build_transitions
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3152, in _build_and_log_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 3214, in _build_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 2692, in get_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 2823, in _get_transitions_for_sim
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 2108, in get_templates_including_carry_transference
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1944, in _get_specs_for_constraints
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1783, in choose_hand_and_filter_specs
  File &quot;T:\InGame\Gameplay\Scripts\Core\caches.py&quot;, line 144, in wrapper
KeyError: (ConstraintSet(...), _TunableAffordanceFilterWrapper._filter, False, &lt;sim '' 0xcbd0553d7cf0dfb&gt;, frozenset({&lt;sim '' 0xcbd0553d7cf0dfb&gt;}), frozenset({(&lt;SI carry_holdobject id:3323 sim:&gt;, &lt;bound method SuperInteraction.is_guaranteed of &lt;SI carry_holdobject id:3323 sim:&gt;&gt;), (&lt;SI generic_consume_food id:3322 sim:&gt;, &lt;bound method SuperInteraction.is_guaranteed of &lt;SI generic_consume_food id:3322 sim:&gt;&gt;), (&lt;SI seating_Sit id:3431 sim:&gt;, &lt;bound method SuperInteraction.is_guaranteed of &lt;SI seating_Sit id:3431 sim:&gt;&gt;)}))

During handling of the above exception, another exception occurred:

Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1781, in choose_hand_and_filter_specs
IndexError: tuple index out of range
rtim=0</desyncdata>
    </report>
</root>
*/


// WEBPACK FOOTER //
// ./src/tests/basegame/postureRuntimeErrorTest.js